import ApiService from '@/services/ApiService';

export default class ChildRecordsApiService extends ApiService {
    constructor() {
        super('child_records');
    }
}
